// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3DJAv","modalForm":"UpgradeEpcsModal_modalForm__OSIpE","modalFooter":"UpgradeEpcsModal_modalFooter__TPYuX"};